import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div<{
	isDark?: boolean;
}>`
	color: ${ifProp('isDark', palette('white'), palette('gray7'))};
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin: 16px 0;
	/* dvh tracks the visible viewport as the mobile URL bar collapses/expands.
	 * The vh line before it is the fallback for browsers without dynamic viewport
	 * units, where overshooting the viewport beats dropping the rule entirely. */
	min-height: calc(100vh - ${theme('navigation.height')}px - 56px);
	min-height: calc(100dvh - ${theme('navigation.height')}px - 56px);

	${minWidth('tablet')} {
		margin: 0;
		min-height: none;
	}
`;

export const TopContent = styled.div`
	width: 100%;
	align-self: flex-start;

	& h1 {
		${fontWeight(FontWeights.Regular)};
		margin-bottom: 24px;

		${minWidth('tablet')} {
			margin-bottom: 32px;
		}
	}
`;
